// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a9G4-","rootNoMargin":"styles_rootNoMargin__3iFQf"};